import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectionsTiles = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6667 1.33333V2.66667H8V1.33333H10.6667ZM4 1.33333V5.33333H1.33333V1.33333H4ZM10.6667 6.66667V10.6667H8V6.66667H10.6667ZM4 9.33333V10.6667H1.33333V9.33333H4ZM12 0H6.66667V4H12V0ZM5.33333 0H0V6.66667H5.33333V0ZM12 5.33333H6.66667V12H12V5.33333ZM5.33333 8H0V12H5.33333V8Z",
		fill: "currentColor"
	})
});
export default SvgSectionsTiles;
